const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://vinhphuc-api.cgis.asia/",
  },
  production: {
      api: "https://vinhphuc-api.cgis.asia/",
  },
};

module.exports = apiEnvironment[env];
